<template>
  <centered-box>
    <b-card title="Sign in" class="title-center" border-variant="primary">
      <div v-if="invalid">
        <div class="loginFailedTitle">
          Login Failed
        </div>
        <div class="loginFailedPara">
          This can happen if the emailed link you clicked was more than 
          15 minutes old, or already used.  (They expire quickly and can be used just once for security reasons.)
        </div>
        <div class="loginFailedPara">
          <b-link to="/signin">Click here to try</b-link> again.
        </div>
      </div>
      <div v-else>
        We're signing you in
        <div class='text-center' style="margin-top: 20px">
          <loading-spinner />
        </div>
        <div class="loginFailedPara">
          (If this lasts more than a minute try logging in again <b-link to="/signin">here</b-link>).
        </div>
      </div>
    </b-card>
  </centered-box>
</template>

<script>
import LoadingSpinner from '@/components/common/LoadingSpinner';
import CenteredBox from '@/components/common/CenteredBox';

const PortalApi = require("@brightoncromwell/portal-api");
const tokensApiInstance = new PortalApi.TokensApi();

export default {
  name: "signin-validate-page",
  metaInfo: {
    title: "SigninValidate"
  },
  components: {
    'loading-spinner': LoadingSpinner,
    'centered-box': CenteredBox
  },
  data() {
    return {
      loading: false,
      invalid: false
    };
  },
  methods: {
    postTokens: function(querystring) {
      this.loading = true;
      const tokenValidation = PortalApi.TokenValidation.constructFromObject({parameters: querystring});
      let opts = { tokenValidation };
      tokensApiInstance.tokensValidatePost(opts, (error, data, response) => {
        this.loading = false;
        if (error) {
          //console.log("tokensApiInstance.tokensValidatePost => Errored out");
          console.error(error);
          this.$emit('onError', response)
        } else {
          console.log("tokensApiInstance.tokensValidatePost => Success!");
          console.log(data);
          const session = { username: data.username };
          const session_json = JSON.stringify(session);
          localStorage.setItem("session", session_json);

          //console.log("Redirecting to RFQs page");
          this.$router.push("/rfqs")
        }
      });
    },
  },
  created() {
    console.log(this.$route.fullPath);
    const querystring = this.$route.fullPath.replace(this.$route.path, "").substring(1);
    console.log("querystring = " + querystring);
    if (querystring.length) {
      this.postTokens(querystring);
    }
    else {
      this.invalid = true;
    }
    
  }
};
</script>

<style scoped>

.loginFailedTitle {
  font-weight:800;
}
.loginFailedPara {
  margin-top: 23px;
}
</style>
